import { render, staticRenderFns } from "./DesktopMenuNextMatches.vue?vue&type=template&id=1100a3be&scoped=true&"
import script from "./DesktopMenuNextMatches.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuNextMatches.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMenuNextMatches.vue?vue&type=style&index=0&id=1100a3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1100a3be",
  null
  
)

export default component.exports